import { render } from "./IconArrowLeft.vue?vue&type=template&id=696753b1&scoped=true"
import script from "./IconArrowLeft.vue?vue&type=script&lang=ts"
export * from "./IconArrowLeft.vue?vue&type=script&lang=ts"

import "./IconArrowLeft.vue?vue&type=style&index=0&id=696753b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-696753b1"

export default script